export default "__VITE_ASSET__DxrqnI2c__"